module.exports = __webpack_public_path__ + "img/notice.04b7443e.png";